import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AdditionalLocationsResponse = {
  __typename?: 'AdditionalLocationsResponse';
  city?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  opeid?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AdmissionOptionsInput = {
  testScore?: InputMaybe<Scalars['Boolean']>;
  transcript?: InputMaybe<Scalars['Boolean']>;
};

export type CostsFilter = {
  programlevel?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rate?: InputMaybe<Scalars['Int']>;
  rateType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tuitionType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FederalAidResponse = {
  __typename?: 'FederalAidResponse';
  avgDisbPerRec?: Maybe<Scalars['Float']>;
  opeid?: Maybe<Scalars['String']>;
  percentOfStudents?: Maybe<Scalars['Float']>;
  totalDisbursements?: Maybe<Scalars['Float']>;
  totalRecipients?: Maybe<Scalars['Float']>;
};

export type GiBillResponse = {
  __typename?: 'GiBillResponse';
  giBillBeneficiaries?: Maybe<Scalars['Int']>;
  numberUndergraduateStudents?: Maybe<Scalars['Int']>;
  opeid?: Maybe<Scalars['String']>;
  percentOfStudents?: Maybe<Scalars['Float']>;
  totalPostPaid?: Maybe<Scalars['Float']>;
};

export type Institution = {
  __typename?: 'Institution';
  acceptanceRate?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  agencyName?: Maybe<Scalars['String']>;
  agencyType?: Maybe<Scalars['String']>;
  allDistanceEnrolledStudents?: Maybe<Scalars['Int']>;
  applicationFee?: Maybe<Scalars['Int']>;
  booksSupplies?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  fullTimeRetentionRate?: Maybe<Scalars['Int']>;
  graduationRate?: Maybe<Scalars['Int']>;
  hasDistance?: Maybe<Scalars['Boolean']>;
  hasInPerson?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  inStateTuition?: Maybe<Scalars['Int']>;
  institutionLevel?: Maybe<Scalars['Int']>;
  medianEarnings?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  noneDistanceEnrolledStudents?: Maybe<Scalars['Int']>;
  opeId?: Maybe<Scalars['String']>;
  outStateTuition?: Maybe<Scalars['Int']>;
  partTimeRetentionRate?: Maybe<Scalars['Int']>;
  roomBoard?: Maybe<Scalars['Int']>;
  someDistanceEnrolledStudents?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  taParticipants?: Maybe<Scalars['Int']>;
  territory?: Maybe<Scalars['String']>;
  testScore?: Maybe<Scalars['Boolean']>;
  totalEnrolledStudents?: Maybe<Scalars['Int']>;
  transcript?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type InstitutionFee = {
  __typename?: 'InstitutionFee';
  amount?: Maybe<Scalars['Float']>;
  feetype?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  opeid?: Maybe<Scalars['String']>;
  programlevel?: Maybe<Scalars['String']>;
  unitid?: Maybe<Scalars['Int']>;
};

export enum InstitutionTypeEnum {
  PrivateForProfit = 'PRIVATE_FOR_PROFIT',
  PrivateNonProfit = 'PRIVATE_NON_PROFIT',
  Public = 'PUBLIC'
}

export type InstitutionsFilterInput = {
  acceptanceRate?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<Pagination>;
  participantsNumber?: InputMaybe<Scalars['Int']>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchByType?: InputMaybe<SearchByTypeInput>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortByEnum>;
};

export type InstitutionsSearchResults = {
  __typename?: 'InstitutionsSearchResults';
  results?: Maybe<Array<Maybe<Institution>>>;
  total?: Maybe<Scalars['Int']>;
};

export type LevelFilterInput = {
  associateLevel?: InputMaybe<Scalars['Int']>;
  bachelorLevel?: InputMaybe<Scalars['Int']>;
  ceritificateLevel?: InputMaybe<Scalars['Int']>;
  masterLevel?: InputMaybe<Scalars['Int']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Program = {
  __typename?: 'Program';
  associateLevel?: Maybe<Scalars['Int']>;
  bachelorLevel?: Maybe<Scalars['Int']>;
  ceritificateLevel?: Maybe<Scalars['Int']>;
  cipCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  masterLevel?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  opeId?: Maybe<Scalars['String']>;
};

export type ProgramTypeInput = {
  associate?: InputMaybe<Scalars['Boolean']>;
  bachelors?: InputMaybe<Scalars['Boolean']>;
  certificate?: InputMaybe<Scalars['Boolean']>;
  masters?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramaRate = {
  __typename?: 'ProgramaRate';
  amount?: Maybe<Scalars['Float']>;
  cipcode?: Maybe<Scalars['String']>;
  credittype?: Maybe<Scalars['String']>;
  opeid?: Maybe<Scalars['String']>;
  programlevel?: Maybe<Scalars['String']>;
  programname?: Maybe<Scalars['String']>;
  tuitiontype?: Maybe<Scalars['String']>;
  unitid?: Maybe<Scalars['Int']>;
};

export type ProgramaRateResponse = {
  __typename?: 'ProgramaRateResponse';
  data?: Maybe<Array<Maybe<ProgramaRate>>>;
  programlevel?: Maybe<Scalars['String']>;
  programname?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getAdditionalLocations?: Maybe<Array<Maybe<AdditionalLocationsResponse>>>;
  getAwardsConferred?: Maybe<Array<Maybe<VaInsightsChartsResponse>>>;
  getCampusBased?: Maybe<FederalAidResponse>;
  getDefaultRates?: Maybe<Array<Maybe<VaInsightsChartsResponse>>>;
  getDirectLoans?: Maybe<FederalAidResponse>;
  getGiBill?: Maybe<GiBillResponse>;
  getGrants?: Maybe<FederalAidResponse>;
  getInstutitonFees?: Maybe<Array<Maybe<InstitutionFee>>>;
  getProgramRates?: Maybe<Array<Maybe<ProgramaRateResponse>>>;
  getStandardRates?: Maybe<Array<Maybe<StandardRate>>>;
  getTAInsights?: Maybe<Array<Maybe<TaInsightsResponse>>>;
  getTaParticipants?: Maybe<TaParticipantResponse>;
  getTuitionTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  getVAInsights?: Maybe<VaInsightsResponse>;
  institutionById?: Maybe<Institution>;
  institutionsSearch?: Maybe<InstitutionsSearchResults>;
  programById?: Maybe<Program>;
  programLevelsByOpeId?: Maybe<Array<Maybe<Scalars['String']>>>;
  programsByOpeId?: Maybe<Array<Maybe<Program>>>;
  programsSearch?: Maybe<Array<Maybe<Program>>>;
  searchLocations: Array<TadLocation>;
};


export type QueryGetAdditionalLocationsArgs = {
  opeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAwardsConferredArgs = {
  opeId: Scalars['String'];
};


export type QueryGetCampusBasedArgs = {
  opeId: Scalars['String'];
};


export type QueryGetDefaultRatesArgs = {
  opeId: Scalars['String'];
};


export type QueryGetDirectLoansArgs = {
  opeId: Scalars['String'];
};


export type QueryGetGiBillArgs = {
  opeId: Scalars['String'];
};


export type QueryGetGrantsArgs = {
  opeId: Scalars['String'];
};


export type QueryGetInstutitonFeesArgs = {
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opeId: Scalars['String'];
};


export type QueryGetProgramRatesArgs = {
  filters?: InputMaybe<CostsFilter>;
  opeId: Scalars['String'];
};


export type QueryGetStandardRatesArgs = {
  filters?: InputMaybe<CostsFilter>;
  opeId: Scalars['String'];
};


export type QueryGetTaInsightsArgs = {
  opeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaParticipantsArgs = {
  opeId: Scalars['String'];
};


export type QueryGetTuitionTypesArgs = {
  opeId: Scalars['String'];
};


export type QueryGetVaInsightsArgs = {
  opeId: Scalars['String'];
};


export type QueryInstitutionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInstitutionsSearchArgs = {
  filters?: InputMaybe<InstitutionsFilterInput>;
};


export type QueryProgramByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryProgramLevelsByOpeIdArgs = {
  opeId: Scalars['String'];
};


export type QueryProgramsByOpeIdArgs = {
  filters?: InputMaybe<SearchProgramsInput>;
  opeId: Scalars['String'];
};


export type QueryProgramsSearchArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QuerySearchLocationsArgs = {
  byCity: Scalars['Boolean'];
  searchTerm: Scalars['String'];
};

export type SearchByTypeInput = {
  admissionType?: InputMaybe<AdmissionOptionsInput>;
  institutionType?: InputMaybe<Array<InputMaybe<InstitutionTypeEnum>>>;
  isTwoYears?: InputMaybe<Scalars['Boolean']>;
  programType?: InputMaybe<ProgramTypeInput>;
  studyOptions?: InputMaybe<StudyOptionsInput>;
};

export type SearchProgramsInput = {
  cipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  levelFilter?: InputMaybe<LevelFilterInput>;
};

export enum SortByEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TaAsc = 'TA_ASC',
  TaDesc = 'TA_DESC'
}

export type StandardRate = {
  __typename?: 'StandardRate';
  credittype?: Maybe<Scalars['String']>;
  maxAmount?: Maybe<Scalars['Float']>;
  minAmount?: Maybe<Scalars['Float']>;
  opeid?: Maybe<Scalars['String']>;
  programlevel?: Maybe<Scalars['String']>;
  tuitiontype?: Maybe<Scalars['String']>;
  unitid?: Maybe<Scalars['Int']>;
};

export type StudyOptionsInput = {
  distance?: InputMaybe<Scalars['Boolean']>;
  inPerson?: InputMaybe<Scalars['Boolean']>;
};

export type TadLocation = {
  __typename?: 'TADLocation';
  cityName: Scalars['String'];
  countyFipsCode?: Maybe<Scalars['Int']>;
  countyName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  marketArea?: Maybe<Scalars['Int']>;
  marketAreaCityName?: Maybe<Scalars['String']>;
  marketAreaStateAbbreviation?: Maybe<Scalars['String']>;
  stateAbbreviation: Scalars['String'];
  territory: Scalars['String'];
  zipCode: Scalars['String'];
};

export type TaInsights = {
  __typename?: 'TAInsights';
  accreditation?: Maybe<Scalars['Float']>;
  certificates?: Maybe<Scalars['Float']>;
  changeInDegreePlan?: Maybe<Scalars['Float']>;
  finacaialIssues?: Maybe<Scalars['Float']>;
  gradePolicy?: Maybe<Scalars['Float']>;
  otherIssues?: Maybe<Scalars['Float']>;
  postGradOpportunities?: Maybe<Scalars['Float']>;
  qualityEducation?: Maybe<Scalars['Float']>;
  recruitingMarketingPractices?: Maybe<Scalars['Float']>;
  refundIssues?: Maybe<Scalars['Float']>;
  releaseOfTranscripts?: Maybe<Scalars['Float']>;
  studentLoans?: Maybe<Scalars['Float']>;
  taAvgCostPerCourse?: Maybe<Scalars['Float']>;
  taCourseCompletion?: Maybe<Scalars['Float']>;
  taFundedCurses?: Maybe<Scalars['Float']>;
  taParticipants?: Maybe<Scalars['Float']>;
  taTotalCost?: Maybe<Scalars['Float']>;
  totalCertsDegrees?: Maybe<Scalars['Float']>;
  transferCredits?: Maybe<Scalars['Float']>;
};

export type TaInsightsResponse = {
  __typename?: 'TAInsightsResponse';
  data?: Maybe<TaInsights>;
  fiscalYear?: Maybe<Scalars['Float']>;
};

export type TaParticipantResponse = {
  __typename?: 'TaParticipantResponse';
  averagePerParticipant?: Maybe<Scalars['Float']>;
  fiscalYear?: Maybe<Scalars['Int']>;
  percentOfStudents?: Maybe<Scalars['Float']>;
  taCosts?: Maybe<Scalars['Float']>;
  taParticipants?: Maybe<Scalars['Int']>;
};

export type VaInsightsChartsResponse = {
  __typename?: 'VAInsightsChartsResponse';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type VaInsightsResponse = {
  __typename?: 'VAInsightsResponse';
  accreditation?: Maybe<Scalars['Float']>;
  avarageBorrowing?: Maybe<Scalars['Float']>;
  changeDegreePlanRequiremnts?: Maybe<Scalars['Float']>;
  compositeScore?: Maybe<Scalars['Float']>;
  dodMemorandum?: Maybe<Scalars['Boolean']>;
  eightKeys?: Maybe<Scalars['Boolean']>;
  financialIssues?: Maybe<Scalars['Float']>;
  gradePolicy?: Maybe<Scalars['Float']>;
  hasYellowRibbon?: Maybe<Scalars['Boolean']>;
  opeId?: Maybe<Scalars['String']>;
  openEnrollment?: Maybe<Scalars['Boolean']>;
  other?: Maybe<Scalars['Float']>;
  postgraduationJobOpportunities?: Maybe<Scalars['Float']>;
  principlesOfExcelence?: Maybe<Scalars['Boolean']>;
  qualityEducation?: Maybe<Scalars['Float']>;
  recruitingMarketingPractices?: Maybe<Scalars['Float']>;
  refundIssues?: Maybe<Scalars['Float']>;
  releaseTranscripts?: Maybe<Scalars['Float']>;
  revenuePercentage?: Maybe<Scalars['Float']>;
  studentLoans?: Maybe<Scalars['Float']>;
  transferCredits?: Maybe<Scalars['Float']>;
};

export type InstitutionFragmentFragment = { __typename?: 'Institution', id?: string | null, name?: string | null, address?: string | null, unitId?: string | null, city?: string | null, state?: string | null, territory?: string | null, zip?: string | null, opeId?: string | null, website?: string | null, institutionLevel?: number | null, totalEnrolledStudents?: number | null, applicationFee?: number | null, type?: string | null, partTimeRetentionRate?: number | null, fullTimeRetentionRate?: number | null, allDistanceEnrolledStudents?: number | null, someDistanceEnrolledStudents?: number | null, noneDistanceEnrolledStudents?: number | null, inStateTuition?: number | null, outStateTuition?: number | null, roomBoard?: number | null, booksSupplies?: number | null, taParticipants?: number | null, acceptanceRate?: number | null, graduationRate?: number | null, medianEarnings?: number | null, transcript?: boolean | null, testScore?: boolean | null, hasDistance?: boolean | null, hasInPerson?: boolean | null, agencyName?: string | null, agencyType?: string | null };

export type InstitutionInCompareFragmentFragment = { __typename?: 'Institution', id?: string | null, name?: string | null, address?: string | null, unitId?: string | null, city?: string | null, state?: string | null, opeId?: string | null, website?: string | null, institutionLevel?: number | null, totalEnrolledStudents?: number | null, applicationFee?: number | null, inStateTuition?: number | null, roomBoard?: number | null, booksSupplies?: number | null, taParticipants?: number | null, acceptanceRate?: number | null, graduationRate?: number | null, agencyName?: string | null, agencyType?: string | null };

export type ProgramFragmentFragment = { __typename?: 'Program', id?: string | null, name?: string | null, cipCode?: string | null, opeId?: string | null, ceritificateLevel?: number | null, associateLevel?: number | null, bachelorLevel?: number | null, masterLevel?: number | null };

export type LocationFragmentFragment = { __typename?: 'TADLocation', territory: string, cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null };

export type TaInsightsFragmentFragment = { __typename?: 'TAInsights', taParticipants?: number | null, taFundedCurses?: number | null, taCourseCompletion?: number | null, taTotalCost?: number | null, totalCertsDegrees?: number | null, taAvgCostPerCourse?: number | null, certificates?: number | null, recruitingMarketingPractices?: number | null, studentLoans?: number | null, qualityEducation?: number | null, transferCredits?: number | null, accreditation?: number | null, postGradOpportunities?: number | null, gradePolicy?: number | null, refundIssues?: number | null, finacaialIssues?: number | null, changeInDegreePlan?: number | null, releaseOfTranscripts?: number | null, otherIssues?: number | null };

export type VaInsightsFragmentFragment = { __typename?: 'VAInsightsResponse', opeId?: string | null, hasYellowRibbon?: boolean | null, principlesOfExcelence?: boolean | null, eightKeys?: boolean | null, financialIssues?: number | null, qualityEducation?: number | null, refundIssues?: number | null, recruitingMarketingPractices?: number | null, accreditation?: number | null, changeDegreePlanRequiremnts?: number | null, studentLoans?: number | null, gradePolicy?: number | null, transferCredits?: number | null, postgraduationJobOpportunities?: number | null, releaseTranscripts?: number | null, other?: number | null, compositeScore?: number | null, revenuePercentage?: number | null, avarageBorrowing?: number | null, openEnrollment?: boolean | null, dodMemorandum?: boolean | null };

export type GiBillResponseFragmentFragment = { __typename?: 'GiBillResponse', opeid?: string | null, giBillBeneficiaries?: number | null, numberUndergraduateStudents?: number | null, percentOfStudents?: number | null, totalPostPaid?: number | null };

export type FederalAidFragmentFragment = { __typename?: 'FederalAidResponse', opeid?: string | null, totalRecipients?: number | null, totalDisbursements?: number | null, avgDisbPerRec?: number | null, percentOfStudents?: number | null };

export type TaParticipantsFragmentFragment = { __typename?: 'TaParticipantResponse', fiscalYear?: number | null, taParticipants?: number | null, taCosts?: number | null, averagePerParticipant?: number | null, percentOfStudents?: number | null };

export type StandardRateFragmentFragment = { __typename?: 'StandardRate', unitid?: number | null, opeid?: string | null, tuitiontype?: string | null, programlevel?: string | null, credittype?: string | null, minAmount?: number | null, maxAmount?: number | null };

export type ProgramaRateFragmentFragment = { __typename?: 'ProgramaRate', tuitiontype?: string | null, credittype?: string | null, amount?: number | null };

export type InstitutionFeeFragmentFragment = { __typename?: 'InstitutionFee', unitid?: number | null, opeid?: string | null, programlevel?: string | null, feetype?: string | null, frequency?: string | null, amount?: number | null };

export type ProgramaRateResponseFragmentFragment = { __typename?: 'ProgramaRateResponse', programname?: string | null, programlevel?: string | null, data?: Array<{ __typename?: 'ProgramaRate', tuitiontype?: string | null, credittype?: string | null, amount?: number | null } | null> | null };

export type AdditionalLocationsResponseFragmentFragment = { __typename?: 'AdditionalLocationsResponse', opeid?: string | null, name?: string | null, city?: string | null, state?: string | null };

export type GetAdditionalLocationsQueryVariables = Exact<{
  opeId?: InputMaybe<Scalars['String']>;
}>;


export type GetAdditionalLocationsQuery = { __typename?: 'Query', getAdditionalLocations?: Array<{ __typename?: 'AdditionalLocationsResponse', opeid?: string | null, name?: string | null, city?: string | null, state?: string | null } | null> | null };

export type GetCostsFederalAidQueryVariables = Exact<{
  filters?: InputMaybe<CostsFilter>;
  opeId: Scalars['String'];
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCostsFederalAidQuery = { __typename?: 'Query', getTuitionTypes?: Array<string | null> | null, getStandardRates?: Array<{ __typename?: 'StandardRate', unitid?: number | null, opeid?: string | null, tuitiontype?: string | null, programlevel?: string | null, credittype?: string | null, minAmount?: number | null, maxAmount?: number | null } | null> | null, getProgramRates?: Array<{ __typename?: 'ProgramaRateResponse', programname?: string | null, programlevel?: string | null, data?: Array<{ __typename?: 'ProgramaRate', tuitiontype?: string | null, credittype?: string | null, amount?: number | null } | null> | null } | null> | null, getInstutitonFees?: Array<{ __typename?: 'InstitutionFee', unitid?: number | null, opeid?: string | null, programlevel?: string | null, feetype?: string | null, frequency?: string | null, amount?: number | null } | null> | null, getDirectLoans?: { __typename?: 'FederalAidResponse', opeid?: string | null, totalRecipients?: number | null, totalDisbursements?: number | null, avgDisbPerRec?: number | null, percentOfStudents?: number | null } | null, getGrants?: { __typename?: 'FederalAidResponse', opeid?: string | null, totalRecipients?: number | null, totalDisbursements?: number | null, avgDisbPerRec?: number | null, percentOfStudents?: number | null } | null, getCampusBased?: { __typename?: 'FederalAidResponse', opeid?: string | null, totalRecipients?: number | null, totalDisbursements?: number | null, avgDisbPerRec?: number | null, percentOfStudents?: number | null } | null, getGiBill?: { __typename?: 'GiBillResponse', opeid?: string | null, giBillBeneficiaries?: number | null, numberUndergraduateStudents?: number | null, percentOfStudents?: number | null, totalPostPaid?: number | null } | null, getTaParticipants?: { __typename?: 'TaParticipantResponse', fiscalYear?: number | null, taParticipants?: number | null, taCosts?: number | null, averagePerParticipant?: number | null, percentOfStudents?: number | null } | null };

export type GetTaInsightsQueryVariables = Exact<{
  opeId?: InputMaybe<Scalars['String']>;
}>;


export type GetTaInsightsQuery = { __typename?: 'Query', getTAInsights?: Array<{ __typename?: 'TAInsightsResponse', fiscalYear?: number | null, data?: { __typename?: 'TAInsights', taParticipants?: number | null, taFundedCurses?: number | null, taCourseCompletion?: number | null, taTotalCost?: number | null, totalCertsDegrees?: number | null, taAvgCostPerCourse?: number | null, certificates?: number | null, recruitingMarketingPractices?: number | null, studentLoans?: number | null, qualityEducation?: number | null, transferCredits?: number | null, accreditation?: number | null, postGradOpportunities?: number | null, gradePolicy?: number | null, refundIssues?: number | null, finacaialIssues?: number | null, changeInDegreePlan?: number | null, releaseOfTranscripts?: number | null, otherIssues?: number | null } | null } | null> | null };

export type GetVaInsightsQueryVariables = Exact<{
  opeId: Scalars['String'];
}>;


export type GetVaInsightsQuery = { __typename?: 'Query', getVAInsights?: { __typename?: 'VAInsightsResponse', opeId?: string | null, hasYellowRibbon?: boolean | null, principlesOfExcelence?: boolean | null, eightKeys?: boolean | null, financialIssues?: number | null, qualityEducation?: number | null, refundIssues?: number | null, recruitingMarketingPractices?: number | null, accreditation?: number | null, changeDegreePlanRequiremnts?: number | null, studentLoans?: number | null, gradePolicy?: number | null, transferCredits?: number | null, postgraduationJobOpportunities?: number | null, releaseTranscripts?: number | null, other?: number | null, compositeScore?: number | null, revenuePercentage?: number | null, avarageBorrowing?: number | null, openEnrollment?: boolean | null, dodMemorandum?: boolean | null } | null, getAwardsConferred?: Array<{ __typename?: 'VAInsightsChartsResponse', key?: string | null, value?: number | null } | null> | null, getDefaultRates?: Array<{ __typename?: 'VAInsightsChartsResponse', key?: string | null, value?: number | null } | null> | null };

export type InstitutionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InstitutionByIdQuery = { __typename?: 'Query', institutionById?: { __typename?: 'Institution', id?: string | null, name?: string | null, address?: string | null, unitId?: string | null, city?: string | null, state?: string | null, territory?: string | null, zip?: string | null, opeId?: string | null, website?: string | null, institutionLevel?: number | null, totalEnrolledStudents?: number | null, applicationFee?: number | null, type?: string | null, partTimeRetentionRate?: number | null, fullTimeRetentionRate?: number | null, allDistanceEnrolledStudents?: number | null, someDistanceEnrolledStudents?: number | null, noneDistanceEnrolledStudents?: number | null, inStateTuition?: number | null, outStateTuition?: number | null, roomBoard?: number | null, booksSupplies?: number | null, taParticipants?: number | null, acceptanceRate?: number | null, graduationRate?: number | null, medianEarnings?: number | null, transcript?: boolean | null, testScore?: boolean | null, hasDistance?: boolean | null, hasInPerson?: boolean | null, agencyName?: string | null, agencyType?: string | null } | null };

export type InstitutionInCompareQueryVariables = Exact<{
  id: Scalars['ID'];
  opeId: Scalars['String'];
}>;


export type InstitutionInCompareQuery = { __typename?: 'Query', programLevelsByOpeId?: Array<string | null> | null, institutionById?: { __typename?: 'Institution', id?: string | null, name?: string | null, address?: string | null, unitId?: string | null, city?: string | null, state?: string | null, opeId?: string | null, website?: string | null, institutionLevel?: number | null, totalEnrolledStudents?: number | null, applicationFee?: number | null, inStateTuition?: number | null, roomBoard?: number | null, booksSupplies?: number | null, taParticipants?: number | null, acceptanceRate?: number | null, graduationRate?: number | null, agencyName?: string | null, agencyType?: string | null, hasInPerson?: boolean | null, hasDistance?: boolean | null } | null, getTAInsights?: Array<{ __typename?: 'TAInsightsResponse', data?: { __typename?: 'TAInsights', taFundedCurses?: number | null, taTotalCost?: number | null } | null } | null> | null, getVAInsights?: { __typename?: 'VAInsightsResponse', dodMemorandum?: boolean | null, principlesOfExcelence?: boolean | null, hasYellowRibbon?: boolean | null, eightKeys?: boolean | null } | null, getGiBill?: { __typename?: 'GiBillResponse', giBillBeneficiaries?: number | null, totalPostPaid?: number | null } | null, getDirectLoans?: { __typename?: 'FederalAidResponse', totalRecipients?: number | null, totalDisbursements?: number | null } | null, getGrants?: { __typename?: 'FederalAidResponse', totalRecipients?: number | null, totalDisbursements?: number | null } | null, getCampusBased?: { __typename?: 'FederalAidResponse', totalRecipients?: number | null, totalDisbursements?: number | null } | null };

export type InstitutionsSearchQueryVariables = Exact<{
  filters?: InputMaybe<InstitutionsFilterInput>;
}>;


export type InstitutionsSearchQuery = { __typename?: 'Query', institutionsSearch?: { __typename?: 'InstitutionsSearchResults', total?: number | null, results?: Array<{ __typename?: 'Institution', id?: string | null, name?: string | null, address?: string | null, unitId?: string | null, city?: string | null, state?: string | null, territory?: string | null, zip?: string | null, opeId?: string | null, website?: string | null, institutionLevel?: number | null, totalEnrolledStudents?: number | null, applicationFee?: number | null, type?: string | null, partTimeRetentionRate?: number | null, fullTimeRetentionRate?: number | null, allDistanceEnrolledStudents?: number | null, someDistanceEnrolledStudents?: number | null, noneDistanceEnrolledStudents?: number | null, inStateTuition?: number | null, outStateTuition?: number | null, roomBoard?: number | null, booksSupplies?: number | null, taParticipants?: number | null, acceptanceRate?: number | null, graduationRate?: number | null, medianEarnings?: number | null, transcript?: boolean | null, testScore?: boolean | null, hasDistance?: boolean | null, hasInPerson?: boolean | null, agencyName?: string | null, agencyType?: string | null } | null> | null } | null };

export type ProgramLevelsByOpeIdQueryVariables = Exact<{
  opeId: Scalars['String'];
}>;


export type ProgramLevelsByOpeIdQuery = { __typename?: 'Query', programLevelsByOpeId?: Array<string | null> | null };

export type ProgramsByOpeIdQueryVariables = Exact<{
  filters?: InputMaybe<SearchProgramsInput>;
  opeId: Scalars['String'];
}>;


export type ProgramsByOpeIdQuery = { __typename?: 'Query', programsByOpeId?: Array<{ __typename?: 'Program', id?: string | null, name?: string | null, cipCode?: string | null, opeId?: string | null, ceritificateLevel?: number | null, associateLevel?: number | null, bachelorLevel?: number | null, masterLevel?: number | null } | null> | null };

export type ProgramsSearchQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']>;
}>;


export type ProgramsSearchQuery = { __typename?: 'Query', programsSearch?: Array<{ __typename?: 'Program', id?: string | null, name?: string | null, cipCode?: string | null, opeId?: string | null, ceritificateLevel?: number | null, associateLevel?: number | null, bachelorLevel?: number | null, masterLevel?: number | null } | null> | null };

export type SearchLocationsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  byCity: Scalars['Boolean'];
}>;


export type SearchLocationsQuery = { __typename?: 'Query', searchLocations: Array<{ __typename?: 'TADLocation', territory: string, cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }> };

export const InstitutionFragmentFragmentDoc = gql`
    fragment institutionFragment on Institution {
  id
  name
  address
  unitId
  city
  state
  territory
  zip
  opeId
  website
  institutionLevel
  totalEnrolledStudents
  applicationFee
  type
  partTimeRetentionRate
  fullTimeRetentionRate
  allDistanceEnrolledStudents
  someDistanceEnrolledStudents
  noneDistanceEnrolledStudents
  inStateTuition
  outStateTuition
  roomBoard
  booksSupplies
  taParticipants
  acceptanceRate
  graduationRate
  medianEarnings
  transcript
  testScore
  hasDistance
  hasInPerson
  agencyName
  agencyType
}
    `;
export const InstitutionInCompareFragmentFragmentDoc = gql`
    fragment institutionInCompareFragment on Institution {
  id
  name
  address
  unitId
  city
  state
  opeId
  website
  institutionLevel
  totalEnrolledStudents
  applicationFee
  inStateTuition
  roomBoard
  booksSupplies
  taParticipants
  acceptanceRate
  graduationRate
  agencyName
  agencyType
}
    `;
export const ProgramFragmentFragmentDoc = gql`
    fragment programFragment on Program {
  id
  name
  cipCode
  opeId
  ceritificateLevel
  associateLevel
  bachelorLevel
  masterLevel
}
    `;
export const LocationFragmentFragmentDoc = gql`
    fragment locationFragment on TADLocation {
  territory
  cityName
  stateAbbreviation
  zipCode
  marketArea
  marketAreaCityName
  marketAreaStateAbbreviation
  countyFipsCode
  countyName
  latitude
  longitude
}
    `;
export const TaInsightsFragmentFragmentDoc = gql`
    fragment taInsightsFragment on TAInsights {
  taParticipants
  taFundedCurses
  taCourseCompletion
  taTotalCost
  totalCertsDegrees
  taAvgCostPerCourse
  certificates
  recruitingMarketingPractices
  studentLoans
  qualityEducation
  transferCredits
  accreditation
  postGradOpportunities
  gradePolicy
  refundIssues
  finacaialIssues
  changeInDegreePlan
  releaseOfTranscripts
  otherIssues
}
    `;
export const VaInsightsFragmentFragmentDoc = gql`
    fragment vaInsightsFragment on VAInsightsResponse {
  opeId
  hasYellowRibbon
  principlesOfExcelence
  eightKeys
  financialIssues
  qualityEducation
  refundIssues
  recruitingMarketingPractices
  accreditation
  changeDegreePlanRequiremnts
  studentLoans
  gradePolicy
  transferCredits
  postgraduationJobOpportunities
  releaseTranscripts
  other
  compositeScore
  revenuePercentage
  avarageBorrowing
  openEnrollment
  dodMemorandum
}
    `;
export const GiBillResponseFragmentFragmentDoc = gql`
    fragment giBillResponseFragment on GiBillResponse {
  opeid
  giBillBeneficiaries
  numberUndergraduateStudents
  percentOfStudents
  totalPostPaid
}
    `;
export const FederalAidFragmentFragmentDoc = gql`
    fragment federalAidFragment on FederalAidResponse {
  opeid
  totalRecipients
  totalDisbursements
  avgDisbPerRec
  percentOfStudents
}
    `;
export const TaParticipantsFragmentFragmentDoc = gql`
    fragment taParticipantsFragment on TaParticipantResponse {
  fiscalYear
  taParticipants
  taCosts
  averagePerParticipant
  percentOfStudents
}
    `;
export const StandardRateFragmentFragmentDoc = gql`
    fragment standardRateFragment on StandardRate {
  unitid
  opeid
  tuitiontype
  programlevel
  credittype
  minAmount
  maxAmount
}
    `;
export const InstitutionFeeFragmentFragmentDoc = gql`
    fragment institutionFeeFragment on InstitutionFee {
  unitid
  opeid
  programlevel
  feetype
  frequency
  amount
}
    `;
export const ProgramaRateFragmentFragmentDoc = gql`
    fragment programaRateFragment on ProgramaRate {
  tuitiontype
  credittype
  amount
}
    `;
export const ProgramaRateResponseFragmentFragmentDoc = gql`
    fragment programaRateResponseFragment on ProgramaRateResponse {
  programname
  programlevel
  data {
    ...programaRateFragment
  }
}
    ${ProgramaRateFragmentFragmentDoc}`;
export const AdditionalLocationsResponseFragmentFragmentDoc = gql`
    fragment additionalLocationsResponseFragment on AdditionalLocationsResponse {
  opeid
  name
  city
  state
}
    `;
export const GetAdditionalLocationsDocument = gql`
    query getAdditionalLocations($opeId: String) {
  getAdditionalLocations(opeId: $opeId) {
    ...additionalLocationsResponseFragment
  }
}
    ${AdditionalLocationsResponseFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdditionalLocationsGQL extends Apollo.Query<GetAdditionalLocationsQuery, GetAdditionalLocationsQueryVariables> {
    override document = GetAdditionalLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCostsFederalAidDocument = gql`
    query getCostsFederalAid($filters: CostsFilter, $opeId: String!, $levels: [String]) {
  getStandardRates(filters: $filters, opeId: $opeId) {
    ...standardRateFragment
  }
  getProgramRates(filters: $filters, opeId: $opeId) {
    ...programaRateResponseFragment
  }
  getInstutitonFees(levels: $levels, opeId: $opeId) {
    ...institutionFeeFragment
  }
  getDirectLoans(opeId: $opeId) {
    ...federalAidFragment
  }
  getGrants(opeId: $opeId) {
    ...federalAidFragment
  }
  getCampusBased(opeId: $opeId) {
    ...federalAidFragment
  }
  getGiBill(opeId: $opeId) {
    ...giBillResponseFragment
  }
  getTaParticipants(opeId: $opeId) {
    ...taParticipantsFragment
  }
  getTuitionTypes(opeId: $opeId)
}
    ${StandardRateFragmentFragmentDoc}
${ProgramaRateResponseFragmentFragmentDoc}
${InstitutionFeeFragmentFragmentDoc}
${FederalAidFragmentFragmentDoc}
${GiBillResponseFragmentFragmentDoc}
${TaParticipantsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCostsFederalAidGQL extends Apollo.Query<GetCostsFederalAidQuery, GetCostsFederalAidQueryVariables> {
    override document = GetCostsFederalAidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTaInsightsDocument = gql`
    query getTAInsights($opeId: String) {
  getTAInsights(opeId: $opeId) {
    fiscalYear
    data {
      ...taInsightsFragment
    }
  }
}
    ${TaInsightsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTaInsightsGQL extends Apollo.Query<GetTaInsightsQuery, GetTaInsightsQueryVariables> {
    override document = GetTaInsightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVaInsightsDocument = gql`
    query getVAInsights($opeId: String!) {
  getVAInsights(opeId: $opeId) {
    ...vaInsightsFragment
  }
  getAwardsConferred(opeId: $opeId) {
    key
    value
  }
  getDefaultRates(opeId: $opeId) {
    key
    value
  }
}
    ${VaInsightsFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVaInsightsGQL extends Apollo.Query<GetVaInsightsQuery, GetVaInsightsQueryVariables> {
    override document = GetVaInsightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionByIdDocument = gql`
    query institutionById($id: ID!) {
  institutionById(id: $id) {
    ...institutionFragment
  }
}
    ${InstitutionFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionByIdGQL extends Apollo.Query<InstitutionByIdQuery, InstitutionByIdQueryVariables> {
    override document = InstitutionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionInCompareDocument = gql`
    query institutionInCompare($id: ID!, $opeId: String!) {
  institutionById(id: $id) {
    id
    name
    address
    unitId
    city
    state
    opeId
    website
    institutionLevel
    totalEnrolledStudents
    applicationFee
    inStateTuition
    roomBoard
    booksSupplies
    taParticipants
    acceptanceRate
    graduationRate
    agencyName
    agencyType
    hasInPerson
    hasDistance
  }
  programLevelsByOpeId(opeId: $opeId)
  getTAInsights(opeId: $opeId) {
    data {
      taFundedCurses
      taTotalCost
    }
  }
  getVAInsights(opeId: $opeId) {
    dodMemorandum
    principlesOfExcelence
    hasYellowRibbon
    eightKeys
  }
  getGiBill(opeId: $opeId) {
    giBillBeneficiaries
    totalPostPaid
  }
  getDirectLoans(opeId: $opeId) {
    totalRecipients
    totalDisbursements
  }
  getGrants(opeId: $opeId) {
    totalRecipients
    totalDisbursements
  }
  getCampusBased(opeId: $opeId) {
    totalRecipients
    totalDisbursements
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionInCompareGQL extends Apollo.Query<InstitutionInCompareQuery, InstitutionInCompareQueryVariables> {
    override document = InstitutionInCompareDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionsSearchDocument = gql`
    query institutionsSearch($filters: InstitutionsFilterInput) {
  institutionsSearch(filters: $filters) {
    total
    results {
      ...institutionFragment
    }
  }
}
    ${InstitutionFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionsSearchGQL extends Apollo.Query<InstitutionsSearchQuery, InstitutionsSearchQueryVariables> {
    override document = InstitutionsSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProgramLevelsByOpeIdDocument = gql`
    query programLevelsByOpeId($opeId: String!) {
  programLevelsByOpeId(opeId: $opeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProgramLevelsByOpeIdGQL extends Apollo.Query<ProgramLevelsByOpeIdQuery, ProgramLevelsByOpeIdQueryVariables> {
    override document = ProgramLevelsByOpeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProgramsByOpeIdDocument = gql`
    query programsByOpeId($filters: SearchProgramsInput, $opeId: String!) {
  programsByOpeId(filters: $filters, opeId: $opeId) {
    ...programFragment
  }
}
    ${ProgramFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProgramsByOpeIdGQL extends Apollo.Query<ProgramsByOpeIdQuery, ProgramsByOpeIdQueryVariables> {
    override document = ProgramsByOpeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProgramsSearchDocument = gql`
    query programsSearch($searchTerm: String) {
  programsSearch(searchTerm: $searchTerm) {
    ...programFragment
  }
}
    ${ProgramFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProgramsSearchGQL extends Apollo.Query<ProgramsSearchQuery, ProgramsSearchQueryVariables> {
    override document = ProgramsSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationsDocument = gql`
    query searchLocations($searchTerm: String!, $byCity: Boolean!) {
  searchLocations(searchTerm: $searchTerm, byCity: $byCity) {
    ...locationFragment @include(if: $byCity)
    territory @skip(if: $byCity)
  }
}
    ${LocationFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationsGQL extends Apollo.Query<SearchLocationsQuery, SearchLocationsQueryVariables> {
    override document = SearchLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }